// @flow strict

import * as React from 'react';
import * as Types from '@ta/trips.trip-types';
import { userRelation } from '@ta/trips.trip-util';
import TrackImpression from './TrackImpression';

type Props = {|
  trip: Types.Trip,
  children: React.Node,
  element?: string,
  detailId?: ?string,
  placeType?: Types.TripsPlaceType,
|};

const TripsDetailImpression = ({ trip, children, element, detailId, placeType }: Props) => {
  const status = trip.status || undefined;
  return (
    <TrackImpression
      source="tripsDetail"
      attributes={{
        tripsDetail: {
          tripId: trip.id,
          status,
          relation: userRelation(trip),
          collaborative: !!trip.collaborators && trip.collaborators.length > 0,
          element,
          detailId,
          placeType,
        },
      }}
    >
      {children}
    </TrackImpression>
  );
};

export default TripsDetailImpression;
